import React, { Component } from 'react';
import $ from 'jquery';

class ConfirmCurrencyModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeConfirm = async (isContinue = false) => {
        const { confirmCurrency } = this.props;
        $('#confirmCurrencyModal').modal('hide');
        if (isContinue) { confirmCurrency(); }
    }

    closeAction = () => {

        $('#confirmCurrencyModal').on('hidden.bs.modal', function () {
        });
    };
    render() {
        const { } = this.props;
        return (
            <div className="modal" tabIndex="-1" role="dialog" id="confirmCurrencyModal" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p>¿Está seguro que desea cambiar de moneda? Se borrarán todas las líneas actuales cuando se cambie a otra moneda</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={() => this.closeConfirm(true)}>Confirmar</button>
                            <button type="button" className="btn botonCorrect text-black" onClick={() => this.closeConfirm()}>Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmCurrencyModal;